export default "__VITE_ASSET__DyOOxDzj__"